<app-configuration-page
  title="Billing Management"
  description="Manage your subscription and payment details."
  [breadcrumbs]="[{ label: 'Billing Management' }]">

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner class="mx-auto"></mat-spinner>
    <p class="mt-3">Loading subscription information...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="alert alert-danger">
    <mat-icon>error</mat-icon>
    There was an error loading your subscription information. Please try again later or contact support.
  </div>

  <!-- No Subscription State -->
  <div *ngIf="subscriptionMissing && !loading && !error" class="alert alert-warning mb-4">
    <mat-icon>info</mat-icon>
    No active subscription found for this account. Please contact support to set up a subscription.
  </div>

  <!-- Main Content Grid -->
  <div class="row g-4" *ngIf="!loading && !error && !subscriptionMissing">
    <!-- Subscription Details Card -->
    <div class="col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Subscription Details</mat-card-title>
          <mat-card-subtitle>Monthly billing information</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="py-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span>Subscription Status</span>
              <span class="status-badge" [ngClass]="'status-badge-' + billingStatus.subscriptionStatus">{{ billingStatus.subscriptionStatus }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span>Last Payment</span>
              <span class="fw-semibold">{{ billingStatus.lastPaymentDate }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span>Next Payment</span>
              <span class="fw-semibold">{{ billingStatus.nextPaymentDate }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="billingStatus.stripeSubscriptionId">
              <span>Subscription ID</span>
              <span class="text-muted small">{{ billingStatus.stripeSubscriptionId }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center pt-3 border-top">
              <span>Monthly Subscription</span>
              <span class="fw-bold fs-4">$499</span>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="openCustomerPortal()">
            <mat-icon>edit</mat-icon>
            Edit Subscription
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- Payment Method Card -->
    <div class="col-md-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Payment Method</mat-card-title>
          <mat-card-subtitle>Payment details</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="py-3">
            <div class="d-flex align-items-center mb-4">
              <mat-icon class="me-3">{{ getPaymentMethodIcon(paymentMethod?.type) }}</mat-icon>
              <div>
                <p class="fw-semibold mb-0">
                  <ng-container *ngIf="paymentMethod?.type === 'card'">
                    {{ capitalize(paymentMethod?.card?.brand) }} Card
                  </ng-container>
                  <ng-container *ngIf="paymentMethod?.type === 'ach_debit'">
                    Bank Account (ACH)
                  </ng-container>
                  <ng-container *ngIf="!paymentMethod">
                    No Payment Method
                  </ng-container>
                </p>
                <p class="text-muted small mb-0">{{ getFormattedPaymentMethod(paymentMethod) }}</p>
              </div>
            </div>
            <div class="border-top pt-3">
              <h3 class="mat-h3">Automatic Payments</h3>
              <mat-checkbox
                [checked]="billingStatus.autoPayEnabled"
                (change)="updateAutoPay($event)"
                class="d-block mb-2">
                Enable automatic monthly payments
              </mat-checkbox>
              <p *ngIf="billingStatus.autoPayEnabled" class="text-muted small">
                Scheduled for the {{ billingStatus.autoPayDate }} of each month
              </p>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="openCustomerPortal()">
            <mat-icon>credit_card</mat-icon>
            Manage Payment Method
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- Payment History Card -->
    <div class="col-12">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Payment History</mat-card-title>
          <mat-card-subtitle>Recent transactions</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="py-3">
            <div *ngIf="!billingStatus.paymentHistory || billingStatus.paymentHistory.length === 0" class="text-center py-4 text-muted">
              No payment history available
            </div>
            <div *ngFor="let payment of billingStatus.paymentHistory"
              class="d-flex justify-content-between align-items-center py-3 border-bottom">
              <div>
                <p class="fw-semibold mb-0">{{ payment.amount }}</p>
                <p class="text-muted small mb-0">{{ payment.date }}</p>
                <p class="text-muted small mb-0" *ngIf="payment.transactionId">ID: {{ payment.transactionId }}</p>
              </div>
              <span class="status-badge" [ngClass]="'status-badge-' + payment.status">{{ payment.status }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

</app-configuration-page>
